
<div class="owner-fields">
  @switch (field.field.canonical_name) {

    @case ('owner') {
      <!-- Owner Field -->
      <div class="input-wrapper-p-dropdown fake-owner">
        <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" [options]="ownerOptions"
            (change)="selectOwnerEmit($event)" [icon]="'remove_red_eye'" [iconColor]="'#F3A536'" [disabled]="disabled || disableOwnerChange">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.division.canonical_name) {
      <!-- Division Field -->
      <div class="input-wrapper-p-dropdown no-top-border">
        <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" [options]="divisionOptions" (change)="selectDivisionEmit($event)">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.franchise.canonical_name) {
      <!-- Franchise Field -->
      <div class="input-wrapper-p-dropdown">
            <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" 
        [options]="(selectedOwner !== OwnerType.Division && disableOwnerChange) ? currentFranchiseOption : ownedFranchiseOptions"
            (change)="selectFranchiseEmit($event)" [icon]="'movie'" [iconColor]="'#4185DE'" [disabled]="disabled || (selectedOwner !== OwnerType.Division && disableOwnerChange)">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.project.canonical_name) {
      <!-- Project Field -->
      <div class="bottom-margin no-top-border">
            <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required"
            [options]="projectOptions$ | async" (change)="selectProjectEmit($event)" [disabled]="disabled || (projectOptions$ | async)?!(projectOptions$ | async).length:true" [placeholder]="placeholder">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.warehouse.canonical_name) {
      <!-- Warehouse Field -->
      <div class="input-wrapper-p-dropdown">
            <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required"
            [options]="warehouseOptions" (change)="selectWarehouseEmit($event)" [icon]="'business'" [iconColor]="'#891EFE'" [disabled]="disabled">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.location.canonical_name) {
      <!-- Location/Warehouse Location Field -->
      <div>
        <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" [options]="locationOptions$ | async" (change)="selectLocationEmit($event)"
            [disabled]="disabled || !(locationOptions$ | async).length" [icon]="'pin_drop'" [iconColor]="'#396A0A'">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.warehouseLocation.canonical_name) {
      <div class="no-top-border">
        <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" [options]="warehouseLocationOptions$ | async"
            [disabled]="disabled || !(warehouseLocationOptions$ | async)?.length || warehouseLocationSubLocationShelfDisabled" (change)="selectWarehouseLocationEmit($event)"
            [icon]="'pin_drop'" [iconColor]="'#396A0A'"></ah-asset-field-input>
      </div>
    }

    @case (standardFields.subLocation.canonical_name) {
      <!-- SubLocation/Warehouse SubLocation Field -->
      <div class="bottom-margin no-top-border">
        <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" [options]="subLocationOptions$ | async"
            [disabled]="disabled || !(subLocationOptions$ | async).length" (change)="selectSubLocationEmit($event)">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.warehouseSubLocation.canonical_name) {
      <div class="no-top-border">
        <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" [options]="(warehouseSubLocationOptions$ | async)"
            [disabled]="disabled || !(warehouseSubLocationOptions$ | async).length || warehouseLocationSubLocationShelfDisabled" (change)="selectWarehouseSubLocationEmit($event)">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.shelf.canonical_name) {
      <!-- Shelf Field -->
      <div class="input-owner-field">
        <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" [disabled]="disabled || warehouseLocationSubLocationShelfDisabled">
        </ah-asset-field-input>
      </div>
    }

    @case (standardFields.storageBox.canonical_name) {
      <!-- Storage Box Field -->
      <div class="bottom-margin no-top-border">
        <ah-asset-field-input [isButton]="true" [group]="assetForm" [field]="field.field" [required]="field.departmentField.required" [options]="storageBoxOptions$ | async" [disabled]="disabled || !(storageBoxOptions$ | async)?.length"
            (change)="selectStorageBoxEmit($event)">
        </ah-asset-field-input>
      </div>
      @if (storageBoxBarcode) {
        <div class="p-dropdown-items-wrapper">
          <mat-form-field class="storagebox-barcode">
            <mat-label>Storage Box Barcode</mat-label>
            <span class="barcode">
              <img src="../../../assets/layout/images/barcode-scan.svg">
              <input matInput disabled [value]="storageBoxBarcode">
            </span>
          </mat-form-field>
        </div>
      }
    }

    @default {
      <!-- No matching canonical_name -->
    }
  }
</div>
